"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authSuiteErrorFactory = void 0;
var models_1 = require("./models");
var createError = function (method) {
    return models_1.Errors[method] || models_1.Errors[models_1.MethodErrorResponse.FALLBACK];
};
exports.authSuiteErrorFactory = {
    createError: createError,
};
